export interface ApplePayPaymentMethodData {
    supportedNetworks?: ApplePayNetwork[];
    merchantIdentifier?: string;
    merchantCapabilities?: ApplePayMerchantCapability[];
    applicationData?: string;
    version?: number;
}

export enum ApplePayNetwork {
    amex = 'amex',
    bancomat = 'bancomat',
    bancontact = 'bancontact',
    cartesBancaires = 'cartesBancaires',
    chinaUnionPay = 'chinaUnionPay',
    dankort = 'dankort',
    discover = 'discover',
    eftpos = 'eftpos',
    electron = 'electron',
    elo = 'elo',
    girocard = 'girocard',
    interac = 'interac',
    jcb = 'jcb',
    mada = 'mada',
    maestro = 'maestro',
    masterCard = 'masterCard',
    mir = 'mir',
    privateLabel = 'privateLabel',
    visa = 'visa',
    vPay = 'vPay',
}

export enum ApplePayMerchantCapability {
    supports3DS = 'supports3DS',
    supportsCredit = 'supportsCredit',
    supportsDebit = 'supportsDebit',
    supportsEMV = 'supportsEMV',
}